import client from "./client";
import type { MySubscription } from "../types/reports";

export const reportsApi = {
  listMySubscriptions: () => client.get<MySubscription[]>("/reports/my-subscriptions"),
  unsubscribe: (subscriptionId: string) =>
    client.delete(`/reports/my-subscriptions/${subscriptionId}`),
};
